import PersonalDetails from '@//views/PersonalDetails.vue';
import CompareQuotes from '@/views/CompareQuotes.vue';
import CompareOffer from '@/views/CompareOffer.vue';
import ThankYou from '@/views/ThankYou.vue';
import ThankyouHundred from '@/views/ThankyouHundred.vue';
import CallbackThankYou from '@/views/CallbackThankYou.vue';
import CheckoutDetails from '@/views/CheckoutDetails.vue';
import ReviewDetails from '@/views/ReviewDetails.vue';

export const routes = [
    {
        path: '/traveller-details',
        name: 'TravellerDetails',
        component: PersonalDetails,
        header_id: 1
    },
    {
        path: '/compare-quotes',
        name: 'CompareQuotes',
        component: CompareQuotes,
        header_id: 2
    },
    {
        path: '/compare-offers',
        name: 'CompareOffer',
        component: CompareOffer,
        header_id: 3
    },
    {
        path: '/review-details',
        name: 'ReviewDetails',
        component: ReviewDetails,
        header_id: 4
    },
    {
        path: '/checkout',
        name: 'CheckoutDetails',
        component: CheckoutDetails,
        header_id: 5
    },
    {
        path: '/thank-you',
        name: 'ThankYou',
        component: ThankYou,
        header_id: 6
    },
    {
        path: '/call-back',
        name: 'CallBack',
        component: CallbackThankYou,
        header_id: 7
    },
    {
        path: '/thank-you-p',
        name: 'ThankYouHundred',
        component: ThankyouHundred,
        header_id: 8
    },
]
